<div class="mat-dialog-container">
  <!-- 明細編輯開始 -->
  <div #head>
    <app-modal-header #modal_header [isDialog]="isDialog" [title]="title" [state]="srv.state" (onOkClick)="doOk($event)"
      (onCancelClick)="doCancel($event)">
    </app-modal-header>
  </div>
  <div class="jk-content">
    <div class="jk-grid-cols-4">
    <app-jkedit  label="股票代號" #MA001Com  id="MA001"  [(value)]="item.MA001" [required]="true"  placeholder="股票代號"  [readonly]="isBrowse"     >
    </app-jkedit>
    <app-jkedit  label="名稱" #MA002Com  id="MA002"  [(value)]="item.MA002" placeholder="名稱"  [readonly]="isBrowse"     >
    </app-jkedit>
    <app-jknumberedit  label="融資乘數" #MA003Com  id="MA003"  [(value)]="item.MA003" placeholder="融資乘數"  [readonly]="isBrowse"     >
    </app-jknumberedit>
    <app-jkedit  label="摘要" #MA006Com  id="MA006"  [(value)]="item.MA006" placeholder="摘要"  [readonly]="isBrowse"     >
    </app-jkedit>
    <app-jknumberedit  label="融券乘數" #MA013Com  id="MA013"  [(value)]="item.MA013" placeholder="融券乘數"  [readonly]="isBrowse"     >
    </app-jknumberedit>
    <app-jkcheckboxYN  label="長期投資" #MA015Com  id="MA015"  [(valueYN)]="item.MA015"  [readonly]="isBrowse"     >
    </app-jkcheckboxYN>
    <app-jkcombobox  label="商品分類" #MA019Com  id="MA019"  [(value)]="item.MA019" [items]="srv.StkMa019List"  [readonly]="isBrowse"     >
    </app-jkcombobox>
    <app-jkcheckboxYN  label="刪除" #MA020Com  id="MA020"  [(valueYN)]="item.MA020"  [readonly]="isBrowse"     >
    </app-jkcheckboxYN>
    <app-jkcheckboxYN  label="夜盤" #MA021Com  id="MA021"  [(valueYN)]="item.MA021"  [readonly]="isBrowse"     >
    </app-jkcheckboxYN>
    <app-jknumberedit  label="證交稅率%" #MA022Com  id="MA022"  [(value)]="item.MA022" placeholder="證交稅率%"  [readonly]="isBrowse"     >
    </app-jknumberedit>
    <app-jkedit  label="XQ股票代號" #MA028Com  id="MA028"  [(value)]="item.MA028" placeholder="XQ股票代號"  [readonly]="isBrowse"     >
    </app-jkedit>
    <app-jkbtnedit  maintable="STKME" item="W01" valueExpr="ME001" displayExpr="ME002"
 label="XQ次標題" #MA029Com  id="MA029"  [(value)]="item.MA029" placeholder="XQ次標題"  [readonly]="isBrowse"     >
    </app-jkbtnedit>
    <app-jkcomboboxN  label="正反向" #MA033Com  id="MA033"  [(value)]="item.MA033" [items]="srv.StkMa033List"  [readonly]="isBrowse"     >
    </app-jkcomboboxN>
    <app-jkedit  label="期貨/股票代號" #MA004Com  id="MA004"  [(value)]="item.MA004" placeholder="期貨/股票代號"  [readonly]="isBrowse"     >
    </app-jkedit>
    <app-jkedit  label="小型期貨代號" #MA005Com  id="MA005"  [(value)]="item.MA005" placeholder="小型期貨代號"  [readonly]="isBrowse"     >
    </app-jkedit>
    <app-jknumberedit  label="原始保證金適用比例" #MA017Com  id="MA017"  [(value)]="item.MA017" placeholder="原始保證金適用比例"  [readonly]="isBrowse"     >
    </app-jknumberedit>
    <app-jkdatefield  label="市價日期" #MA030Com  id="MA030"  [(value)]="item.MA030" placeholder="市價日期"  [readonly]="isBrowse"
            >
    </app-jkdatefield>
    <app-jktext  label="市價時間" [value]="item.MA031"     >
    </app-jktext>
    <app-jkedit  label="群益期貨對帳代號" #MA046Com  id="MA046"  [(value)]="item.MA046" placeholder="群益期貨對帳代號"  [readonly]="isBrowse"     >
    </app-jkedit>
    <app-jkedit  label="群組" #MA047Com  id="MA047"  [(value)]="item.MA047" placeholder="群組"  [readonly]="isBrowse"     >
    </app-jkedit>
    <app-jktext  label="時間迄" [value]="item.TIME2"     >
    </app-jktext>
    <app-jkedit  label="夜盤迄" #TIME4Com  id="TIME4"  [(value)]="item.TIME4" placeholder="夜盤迄"  [readonly]="isBrowse"     >
    </app-jkedit>
    <app-jkedit  label="夜盤起" #TIME3Com  id="TIME3"  [(value)]="item.TIME3" placeholder="夜盤起"  [readonly]="isBrowse"     >
    </app-jkedit>
    <app-jkedit  label="交易所下單代碼" #MA035Com  id="MA035"  [(value)]="item.MA035" placeholder="交易所下單代碼"  [readonly]="isBrowse"     >
    </app-jkedit>
    <app-jktext  label="時間起" [value]="item.TIME1"     >
    </app-jktext>
    <app-jkdatefield  label="期貨結算日" #MA036Com  id="MA036"  [(value)]="item.MA036" placeholder="期貨結算日"  [readonly]="isBrowse"
            >
    </app-jkdatefield>
    <app-jkedit  label="商品下單代碼" #MA034Com  id="MA034"  [(value)]="item.MA034" placeholder="商品下單代碼"  [readonly]="isBrowse"     >
    </app-jkedit>

    </div>
  </div>
</div>
